/* Curl Hub: tabs, search and pagination for sections/main-curl-hub.liquid.
   Articles come from the CurlHubData JSON the section prints; the server only
   renders the first page, so this script renders every page from that data. */
(function () {
  var root = document.querySelector('[data-curl-hub]');
  if (!root) return;

  var id = root.dataset.sectionId;
  var hubUrl = root.dataset.hubUrl || '/pages/curl-hub';
  var perPage = parseInt(root.dataset.perPage, 10) || 12;
  var dataEl = document.getElementById('CurlHubData-' + id);
  var grid = document.getElementById('CurlHubGrid-' + id);
  var pager = document.getElementById('CurlHubPagination-' + id);
  var countEl = document.getElementById('CurlHubCount-' + id);
  var emptyEl = document.getElementById('CurlHubEmpty-' + id);
  var clearBtn = document.getElementById('CurlHubClear-' + id);
  var input = document.getElementById('CurlHubSearch-' + id);
  var form = document.querySelector('[data-curl-hub-search]');
  var heading = document.querySelector('[data-curl-hub-heading]');
  var tabs = Array.prototype.slice.call(document.querySelectorAll('[data-curl-hub-tab]'));
  if (!dataEl || !grid) return;

  var articles = [];
  try { articles = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var readMore = (grid.querySelector('.curl-hub-card-foot a') || {}).textContent;
  readMore = (readMore || 'Read more →').replace(/\s+/g, ' ').trim();
  if (readMore.indexOf('→') === -1) readMore += ' →';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function handleize(s) {
    return String(s || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function pathOf(href) {
    try { return new URL(href, location.origin).pathname.replace(/\/+$/, '') || '/'; } catch (e) { return ''; }
  }

  var state = { topic: root.dataset.initialTopic || 'all', q: '', page: 1 };

  function tabByTopic(topic) {
    return tabs.filter(function (t) { return t.dataset.topic === topic; })[0] || null;
  }

  function readUrl(initial) {
    var params = new URLSearchParams(location.search);
    var page = parseInt(params.get('page'), 10);
    state.page = page > 0 ? page : 1;
    state.q = params.get('q') || '';
    var topicParam = params.get('topic');
    if (topicParam && tabByTopic(topicParam)) {
      state.topic = topicParam;
    } else if (!initial) {
      var path = pathOf(location.href);
      var hit = tabs.filter(function (t) { return pathOf(t.href) === path; })[0];
      state.topic = hit ? hit.dataset.topic : 'all';
    }
    if (input) input.value = state.q;
  }

  function matches(a) {
    var tab = tabByTopic(state.topic);
    if (tab && state.topic !== 'all') {
      var mode = tab.dataset.match;
      var value = tab.dataset.value || '';
      var tags = (a.tags || []).map(handleize);
      if (mode === 'blog') {
        if (a.blogHandle !== value) return false;
      } else if (mode === 'multiple_tags') {
        var wanted = value.split(',').map(handleize).filter(Boolean);
        if (!wanted.some(function (w) { return tags.indexOf(w) > -1; })) return false;
      } else if (tags.indexOf(handleize(value)) === -1) {
        return false;
      }
    }
    if (state.q) {
      var hay = [a.title, a.excerpt, a.blog, (a.tags || []).join(' ')].join(' ').toLowerCase();
      if (hay.indexOf(state.q.toLowerCase()) === -1) return false;
    }
    return true;
  }

  function card(a) {
    var img = a.image
      ? '<div class="aspect-w-4 aspect-h-3"><img src="' + esc(a.image) + '" alt="' + esc(a.imageAlt) + '"' +
        (a.imageWidth ? ' width="' + a.imageWidth + '"' : '') + (a.imageHeight ? ' height="' + a.imageHeight + '"' : '') +
        ' loading="lazy" class="w-full h-full object-cover"></div>'
      : '';
    var chip = a.tags && a.tags.length ? '<span class="curl-hub-chip">' + esc(a.tags[0]) + '</span>' : '';
    return '<li class="curl-hub-card card">' +
      '<a href="' + esc(a.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
      '<div class="curl-hub-card-body">' + chip +
      '<h3 class="font-heading"><a href="' + esc(a.url) + '">' + esc(a.title) + '</a></h3>' +
      '<p class="curl-hub-excerpt">' + esc(a.excerpt) + '</p>' +
      '<div class="curl-hub-card-foot"><span>' + esc(a.blog) + ' · ' + esc(a.date) + '</span>' +
      '<a href="' + esc(a.url) + '">' + esc(readMore) + '</a></div></div></li>';
  }

  function baseUrl() {
    var tab = tabByTopic(state.topic);
    if (!tab || state.topic === 'all') return hubUrl;
    return tab.getAttribute('href');
  }

  function urlFor(page) {
    var url = new URL(baseUrl(), location.origin);
    var params = new URLSearchParams(url.search);
    if (page > 1) params.set('page', page);
    if (state.q) params.set('q', state.q);
    var s = params.toString();
    return url.pathname + (s ? '?' + s : '');
  }

  function renderPager(totalPages) {
    if (!pager) return;
    if (totalPages <= 1) { pager.hidden = true; pager.innerHTML = ''; return; }
    pager.hidden = false;
    var html = '', last = 0;
    for (var p = 1; p <= totalPages; p++) {
      if (p === 1 || p === totalPages || Math.abs(p - state.page) <= 2) {
        if (last && p > last + 1) html += '<span class="curl-hub-pagination-ellipsis" aria-hidden="true">&hellip;</span>';
        html += '<a href="' + esc(urlFor(p)) + '" data-page="' + p + '"' +
          (p === state.page ? ' aria-current="page"' : '') + '>' + p + '</a>';
        last = p;
      }
    }
    pager.innerHTML = html;
  }

  function render() {
    var list = articles.filter(matches);
    var totalPages = Math.max(1, Math.ceil(list.length / perPage));
    if (state.page > totalPages) state.page = totalPages;
    var slice = list.slice((state.page - 1) * perPage, state.page * perPage);

    grid.innerHTML = slice.map(card).join('');
    grid.hidden = list.length === 0;
    if (emptyEl) emptyEl.hidden = list.length !== 0;
    if (countEl) countEl.textContent = list.length + ' article' + (list.length === 1 ? '' : 's');
    if (clearBtn) clearBtn.hidden = !(state.q || state.topic !== 'all');
    renderPager(totalPages);

    tabs.forEach(function (t) {
      var on = t.dataset.topic === state.topic;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on) t.setAttribute('aria-current', 'page'); else t.removeAttribute('aria-current');
    });
    var active = tabByTopic(state.topic);
    if (heading && active && active.dataset.heading) heading.textContent = active.dataset.heading;
  }

  function go(push, scroll) {
    render();
    if (push) history.pushState({ curlHub: true }, '', urlFor(state.page));
    if (scroll) {
      var top = grid.getBoundingClientRect().top + window.pageYOffset - 140;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }
  }

  tabs.forEach(function (t) {
    t.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
      e.preventDefault();
      state.topic = t.dataset.topic;
      state.page = 1;
      go(true, false);
    });
  });

  if (pager) {
    pager.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-page]');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      state.page = parseInt(a.dataset.page, 10);
      go(true, true);
    });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      state.q = (input.value || '').trim();
      state.page = 1;
      go(true, false);
    });
  }
  if (input) {
    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        state.q = (input.value || '').trim();
        state.page = 1;
        go(false, false);
        history.replaceState({ curlHub: true }, '', urlFor(1));
      }, 200);
    });
  }
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      state.topic = 'all'; state.q = ''; state.page = 1;
      if (input) input.value = '';
      go(true, false);
    });
  }

  window.addEventListener('popstate', function () { readUrl(false); render(); });

  readUrl(true);
  render();
})();
